import { render, staticRenderFns } from "./VehicleConfirm.vue?vue&type=template&id=3c906562&scoped=true&"
import script from "./VehicleConfirm.vue?vue&type=script&lang=js&"
export * from "./VehicleConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c906562",
  null
  
)

export default component.exports